<template>
  <div class="fullpage-container">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="navbar-container">
        <div class="logo-container">
          <img src="@/img/home/logo.webp" :alt="$t('home.yayChat')" class="logo" />
          <span class="logo-text">{{ $t('home.yayChat') }}</span>
        </div>
        <nav class="nav-links">
          <a @click="scrollToSection(0)" class="nav-link" :class="{ active: currentSection === 0 }">{{ $t('home.home') }}</a>
          <a @click="scrollToSection(1)" class="nav-link" :class="{ active: currentSection === 1 }">{{ $t('home.features') }}</a>
          <a @click="scrollToSection(4)" class="nav-link" :class="{ active: currentSection === 4 }">{{ $t('home.reviews') }}</a>
          <a href="#" class="top-up-btn desktop-only" @click="toRecharge">{{ $t('home.topUp') }}</a>
        </nav>
        <a href="#" class="top-up-btn mobile-only" @click="toRecharge">{{ $t('home.topUp') }}</a>
      </div>
    </header>

    <!-- 5个全屏部分 -->
    <div class="fullpage-wrapper" :style="{ transform: `translateY(-${currentSection * 100}vh)` }">
      <!-- 第0部分-->
      <section class="fullpage-section"
        style="background: linear-gradient(248.66deg, #EACBFB 0%, #DCDEFE 50.48%, #F9EAFD 100%);">
        <img src="@/img/home/icon-01.webp" alt="" class="bg-image1">
        <img src="@/img/home/icon-00.webp" alt="" class="bg-image2">
        <div class="section-0-desc">{{ $t('home.joinOurFreeAndExcitingVoiceChatAppShareStoriesIdeasAndJoinOnlinePartiesAnytimeAnywhereAddSomeFunWithInteractiveFeaturesInTheApp') }}</div>

        <!-- 下载按钮区域 -->
        <div class="section-0-buttons">
          <!-- <div class="download-btn flex items-center justify-center" @click="openAppStore">
            <img src="@/img/home/pwa.svg" :alt="$t('home.appStore')" class="pwa-icon">
            <div class="flex flex-col ml-2">
              <span class="text-xs">{{ $t('home.viewItOn') }}</span>
              <span class="channel-name">{{ $t('home.officialSite') }}</span>
            </div>
          </div> -->
          <div class="download-btn flex items-center justify-center" @click="openGooglePlay">
            <img src="@/img/home/google-icon.webp" :alt="$t('home.googlePlay')">
            <div class="flex flex-col ml-2">
              <span class="text-xs">{{ $t('home.getItOn') }}</span>
              <span class="channel-name">{{ $t('home.googlePlay') }}</span>
            </div>
          </div>

          <div class="download-btn flex items-center justify-center" @click="openOfficialWebsite">
            <img src="@/img/home/android-icon.png" :alt="$t('home.officialWebsite')">
            <div class="flex flex-col ml-2">
              <span class="text-xs">{{ $t('home.downloadFrom') }}</span>
              <span class="channel-name">{{ $t('home.officialSite') }}</span>
            </div>
          </div>
        </div>
      </section>
      <!-- 第一部分 -->
      <section class="fullpage-section bg-white">
        <div class="section-content container mx-auto   px-4 lg:px-8">
          <div
            class="flex flex-col lg:flex-row lg:items-center min-h-0 lg:min-h-screen pt-12 pb-6 sm:pt-14 sm:pb-10 md:pt-28 md:pb-16 lg:py-0">
            <!-- 左侧文字内容 -->
            <div class="lg:w-1/2 z-10">
              <h1
                class="text-4xl md:text-5xl lg:text-6xl font-medium mb-6 text-[rgba(51,51,51,1)] max-w-full lg:max-w-[520px]">
                {{ $t('home.onlineParty') }}<br>
                {{ $t('home.micOnAnytime') }}
              </h1>
              <p class="text-lg md:text-xl max-w-full md:max-w-[650px] lg:max-w-[680px] text-[rgba(85, 76, 102, 1)]"
                style="color:rgba(85, 76, 102, 1);">
                {{ $t('home.section1Desc') }}
              </p>
            </div>

            <!-- 右侧图片 -->
            <div class="lg:w-1/2 mt-6 sm:mt-10 lg:mt-0 relative">
              <div class="relative z-10 transform lg:scale-110">
                <div class="relative">
                  <img :src="homeImages.section1" :alt="$t('home.yaychatApp')" class="mx-auto relative z-10" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 第二部分-->
      <section class="fullpage-section bg-[rgba(254,244,254,1)]">
        <div class="section-content container mx-auto px-4 lg:px-8">
          <div
            class="flex flex-col lg:flex-row lg:items-center min-h-0 lg:min-h-screen pt-12 pb-6 sm:pt-14 sm:pb-10 md:pt-28 md:pb-16 lg:py-0">
            <!-- 左侧文字内容 -->
            <div class="lg:w-1/2 z-10">
              <h1
                class="text-4xl md:text-5xl lg:text-6xl font-medium mb-6 text-[rgba(51,51,51,1)] max-w-full lg:max-w-[520px]">
                {{ $t('home.imChatFast') }}<br /> {{ $t('home.stayConnected') }}
              </h1>
              <p class="text-lg md:text-xl max-w-full md:max-w-[650px] lg:max-w-[680px] text-[rgba(85, 76, 102, 1)]"
                style="color:rgba(85, 76, 102, 1);">
                {{ $t('home.section2Desc') }}
              </p>
            </div>

            <!-- 右侧图片 -->
            <div class="lg:w-1/2 mt-6 sm:mt-10 lg:mt-0 relative">
              <div class="relative z-10 transform lg:scale-110">
                <div class="relative">
                  <img :src="homeImages.section2" :alt="$t('home.yaychatApp')" class="mx-auto relative z-10" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 第三部分-->
      <section class="fullpage-section bg-white">
        <div class="section-content container mx-auto px-4 lg:px-8">
          <div
            class="flex flex-col lg:flex-row lg:items-center min-h-0 lg:min-h-screen pt-12 pb-5 sm:pt-12 sm:pb-8 md:pt-24 md:pb-14 lg:py-0">
            <!-- 左侧文字内容 -->
            <div class="lg:w-1/2 z-10">
              <h1
                class="text-4xl md:text-5xl lg:text-6xl font-medium mb-6 text-[rgba(51,51,51,1)] max-w-full lg:max-w-[520px]">
                {{ $t('home.dragonFleet') }} <br />{{ $t('home.dominion') }}
              </h1>
              <p class="text-lg md:text-xl max-w-full md:max-w-[650px] lg:max-w-[680px] text-[rgba(85, 76, 102, 1)]"
                style="color:rgba(85, 76, 102, 1);">
                {{ $t('home.section3Desc') }}
              </p>
            </div>

            <!-- 右侧图片 -->
            <div class="lg:w-1/2 mt-6 sm:mt-10 lg:mt-0 relative">
              <div class="relative z-10 transform lg:scale-110">
                <div class="relative">
                  <img :src="homeImages.section3" :alt="$t('home.yaychatApp')" class="mx-auto relative z-10" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 第四部分 -->
      <section class="fullpage-section section-4" style="background: #FFF3FF;">
        <div class="section-content container mx-auto px-4 lg:px-8">
          <!-- 标题部分 - 确保始终可见 -->
          <div class="testimonials-header">
            <h2 class="testimonials-title">{{ $t('home.psstTheyReLovingIt') }}</h2>
            <p class="testimonials-subtitle">
              {{ $t('home.testimonialSubtitle') }}
            </p>
          </div>

          <div class="testimonials-container">
            <!-- 评价卡片区域 -->
            <div class="testimonials-grid">
              <!-- 第一列 - 向上滚动 -->
              <div class="testimonial-column column-1">
                <div class="testimonial-column-inner">
                  <!-- 评价卡片 1 -->
                  <div class="testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.devsWhoActuallyListen') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewDevsListen') }}</p>
                    <p class="testimonial-author">{{ $t('home.alexChen') }}</p>
                  </div>

                  <!-- 评价卡片 2 -->
                  <div class="testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.surprisinglyFunAndSocial') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewSurprisinglyFun') }}</p>
                    <p class="testimonial-author">{{ $t('home.mayaPatel') }}</p>
                  </div>

                  <!-- 只在小屏幕和中屏幕上显示的评价卡片 -->
                  <div class="small-screen-only testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.delete3OtherDatingAppsBecauseThisApp') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewDeleteOtherApps') }}</p>
                    <p class="testimonial-author">{{ $t('home.jordanKim') }}</p>
                  </div>

                  <div class="small-screen-only testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.simpleFunAndEngaging') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewSimpleFun') }}</p>
                    <p class="testimonial-author">{{ $t('home.taylorBrooks') }}</p>
                  </div>

                  <!-- 只在小屏幕上显示的评价卡片 -->
                  <div class="mobile-only-card testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.finallyASocialAppThatDoesnTFeelFake') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewDoesntFeelFake') }}</p>
                    <p class="testimonial-author">{{ $t('home.caseyReed') }}</p>
                  </div>

                  <div class="mobile-only-card testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.accidentallyMadeAWholeFriendGroup') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewFriendGroup') }}</p>
                    <p class="testimonial-author">{{ $t('home.rileySong') }}</p>
                  </div>

                  <!-- 完整复制所有卡片确保无缝循环 -->
                  <div class="testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.devsWhoActuallyListen') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewDevsListen') }}</p>
                    <p class="testimonial-author">{{ $t('home.alexChen') }}</p>
                  </div>

                  <div class="testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.surprisinglyFunAndSocial') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewSurprisinglyFun') }}</p>
                    <p class="testimonial-author">{{ $t('home.mayaPatel') }}</p>
                  </div>

                  <div class="small-screen-only testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.delete3OtherDatingAppsBecauseThisApp') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewDeleteOtherApps') }}</p>
                    <p class="testimonial-author">{{ $t('home.jordanKim') }}</p>
                  </div>

                  <div class="small-screen-only testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.simpleFunAndEngaging') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewSimpleFun') }}</p>
                    <p class="testimonial-author">{{ $t('home.taylorBrooks') }}</p>
                  </div>

                  <div class="mobile-only-card testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.finallyASocialAppThatDoesnTFeelFake') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewDoesntFeelFake') }}</p>
                    <p class="testimonial-author">{{ $t('home.caseyReed') }}</p>
                  </div>

                  <div class="mobile-only-card testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.accidentallyMadeAWholeFriendGroup') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewFriendGroup') }}</p>
                    <p class="testimonial-author">{{ $t('home.rileySong') }}</p>
                  </div>
                </div>
              </div>

              <!-- 第二列 - 向上滚动，中屏和大屏显示 -->
              <div class="testimonial-column column-2 medium-large-screen">
                <div class="testimonial-column-inner">
                  <!-- 评价卡片 3 -->
                  <div class="testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.delete3OtherDatingAppsBecauseThisApp') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewDeleteOtherApps') }}</p>
                    <p class="testimonial-author">{{ $t('home.jordanKim') }}</p>
                  </div>

                  <!-- 评价卡片 4 -->
                  <div class="testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.simpleFunAndEngaging') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewSimpleFun') }}</p>
                    <p class="testimonial-author">{{ $t('home.taylorBrooks') }}</p>
                  </div>

                  <!-- 只在中屏幕上显示的评价卡片 -->
                  <div class="medium-screen-only testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.didnTPlanToStayButHereIAmEveryNight') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewDidntPlanToStay') }}</p>
                    <p class="testimonial-author">{{ $t('home.samParker') }}</p>
                  </div>

                  <div class="medium-screen-only testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.moreThanJustAnotherChatApp') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewMoreThanChat') }}</p>
                    <p class="testimonial-author">{{ $t('home.morganLee') }}</p>
                  </div>

                  <!-- 完整复制所有卡片确保无缝循环 -->
                  <div class="testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.delete3OtherDatingAppsBecauseThisApp') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewDeleteOtherApps') }}</p>
                    <p class="testimonial-author">{{ $t('home.jordanKim') }}</p>
                  </div>

                  <div class="testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.simpleFunAndEngaging') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewSimpleFun') }}</p>
                    <p class="testimonial-author">{{ $t('home.taylorBrooks') }}</p>
                  </div>

                  <div class="medium-screen-only testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.didnTPlanToStayButHereIAmEveryNight') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewDidntPlanToStay') }}</p>
                    <p class="testimonial-author">{{ $t('home.samParker') }}</p>
                  </div>

                  <div class="medium-screen-only testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.moreThanJustAnotherChatApp') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewMoreThanChat') }}</p>
                    <p class="testimonial-author">{{ $t('home.morganLee') }}</p>
                  </div>
                </div>
              </div>

              <!-- 第三列 - 向上滚动但速度较慢，只在大屏显示 -->
              <div class="testimonial-column column-3 large-screen-only">
                <div class="testimonial-column-inner">
                  <!-- 评价卡片 5 -->
                  <div class="testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.itWentDownOnceButNowItSMuchBetter') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewMuchBetter') }}</p>
                    <p class="testimonial-author">{{ $t('home.devonMartinez') }}</p>
                  </div>

                  <!-- 评价卡片 6 -->
                  <div class="testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.feelsAliveNotScripted') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewFeelsAlive') }}</p>
                    <p class="testimonial-author">{{ $t('home.averyThompson') }}</p>
                  </div>

                  <!-- 完整复制所有卡片确保无缝循环 -->
                  <div class="testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.itWentDownOnceButNowItSMuchBetter') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewMuchBetter') }}</p>
                    <p class="testimonial-author">{{ $t('home.devonMartinez') }}</p>
                  </div>

                  <div class="testimonial-card">
                    <div class="rating">
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                      <span class="star">★</span>
                    </div>
                    <h3 class="testimonial-title">{{ $t('home.feelsAliveNotScripted') }}</h3>
                    <p class="testimonial-text">{{ $t('home.reviewFeelsAlive') }}</p>
                    <p class="testimonial-author">{{ $t('home.averyThompson') }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>

    <!-- 侧边导航点 -->
    <!-- <div class="pagination">
      <div v-for="(_, index) in 5" :key="index" @click="scrollToSection(index)"
        :class="['pagination-dot', { 'active': currentSection === index }]"></div>
    </div> -->

    <!-- Footer样式 -->
    <footer class="footer">
      <div class="footer-container">
        <div class="footer-left">
          <span class="copyright">{{ $t('home.copyright2023YaychatAllRightsReserved') }}</span>
        </div>
        <div class="footer-right">
          <a href="#" class="footer-link"
            @click="checkUserAgreement">{{ $t('home.userAgreement') }}</a>
          <span class="separator">|</span>
          <a href="#" class="footer-link"
            @click="checkPrivacyPolicy">{{ $t('home.privacyPolicy') }}</a>
          <span class="separator">|</span>
          <span class="contact">{{ $t('home.contactUs7865190551') }}</span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import router from '#/router'
import icon1 from '@/img/home/icon-1.webp';
import icon2 from '@/img/home/icon-2.webp';
import icon3 from '@/img/home/icon-3.webp';
import jaIcon1 from '@/img/home/ja-icon-1.webp';
import jaIcon2 from '@/img/home/ja-icon-2.webp';
import jaIcon3 from '@/img/home/ja-icon-3.webp';

const { locale } = useI18n();
const isJaLocale = computed(() => String(locale.value).startsWith('ja'));
const homeImages = computed(() => ({
  section1: isJaLocale.value ? jaIcon1 : icon1,
  section2: isJaLocale.value ? jaIcon2 : icon2,
  section3: isJaLocale.value ? jaIcon3 : icon3,
}));

// 当前部分的索引
const currentSection = ref(0);
// 总部分数
const totalSections = 5;
// 是否正在滚动
const isScrolling = ref(false);
// 触摸开始位置
const touchStartY = ref(0);
// wheel事件防抖相关
const lastWheelTime = ref(0);
const wheelDeltaAccumulator = ref(0);
const wheelThreshold = 50; // 滚动阈值
const wheelDelay = 300; // 防抖延迟（毫秒）

// 下载按钮点击事件
const openAppStore = () => {
  // window.open('https://apps.apple.com/us/app/yaychat-voice-chat-rooms/id6459409309', '_blank');
  window.open(import.meta.env.VITE_PWA_URL, '_blank');
};

const openGooglePlay = () => {
  window.open('https://play.google.com/store/apps/details?id=chat.yay.app', '_blank');
};

const openOfficialWebsite = () => {
  window.open('https://cdn.yay1.xyz/apks/yaychat-gw.apk', '_blank');
};

const checkUserAgreement = () => {
  window.open(`${window.location.origin}/agreements/UserAgreement.html`, '_blank');
};

const checkPrivacyPolicy = () => {
  window.open(`${window.location.origin}/agreements/PrivacyPolicy.html`, '_blank');
};

const toRecharge = () => {
  router.push({ name: 'recharge' });
};

// 滚动到特定部分
const scrollToSection = (index) => {
  if (index >= 0 && index < totalSections && !isScrolling.value) {
    isScrolling.value = true;
    currentSection.value = index;
    setTimeout(() => {
      isScrolling.value = false;
    }, 1000); // 动画持续时间
  }
};

// 处理鼠标滚轮事件
const handleWheel = (e) => {
  e.preventDefault();

  const now = Date.now();

  // 如果正在滚动中，直接返回
  if (isScrolling.value) {
    wheelDeltaAccumulator.value = 0;
    return;
  }

  // 时间间隔检查
  if (now - lastWheelTime.value < 50) {
    wheelDeltaAccumulator.value += Math.abs(e.deltaY);
  } else {
    wheelDeltaAccumulator.value = Math.abs(e.deltaY);
  }

  lastWheelTime.value = now;

  // 只有累积的滚动量超过阈值时才触发页面切换
  if (wheelDeltaAccumulator.value > wheelThreshold) {
    wheelDeltaAccumulator.value = 0;

    if (e.deltaY > 0) {
      // 向下滚动
      scrollToSection(Math.min(currentSection.value + 1, totalSections - 1));
    } else {
      // 向上滚动
      scrollToSection(Math.max(currentSection.value - 1, 0));
    }
  }
};

// 处理触摸事件
const handleTouchStart = (e) => {
  touchStartY.value = e.touches[0].clientY;
};

const handleTouchMove = (e) => {
  if (isScrolling.value) return;

  const touchY = e.touches[0].clientY;
  const diff = touchStartY.value - touchY;

  // 设置一个阈值，以确定滚动方向
  if (Math.abs(diff) > 50) {
    if (diff > 0) {
      // 向下滑动
      scrollToSection(Math.min(currentSection.value + 1, totalSections - 1));
    } else {
      // 向上滑动
      scrollToSection(Math.max(currentSection.value - 1, 0));
    }
    touchStartY.value = touchY;
  }
};

// 处理键盘事件
const handleKeyDown = (e) => {
  if (isScrolling.value) return;

  if (e.key === 'ArrowDown' || e.key === 'PageDown') {
    scrollToSection(Math.min(currentSection.value + 1, totalSections - 1));
  } else if (e.key === 'ArrowUp' || e.key === 'PageUp') {
    scrollToSection(Math.max(currentSection.value - 1, 0));
  }
};

// 添加事件监听器
onMounted(() => {
  window.addEventListener('wheel', handleWheel, { passive: false, capture: true });
  window.addEventListener('touchstart', handleTouchStart, { passive: true });
  window.addEventListener('touchmove', handleTouchMove, { passive: false });
  window.addEventListener('keydown', handleKeyDown);
});

// 移除事件监听器
onBeforeUnmount(() => {
  window.removeEventListener('wheel', handleWheel, { capture: true });
  window.removeEventListener('touchstart', handleTouchStart);
  window.removeEventListener('touchmove', handleTouchMove);
  window.removeEventListener('keydown', handleKeyDown);
});
</script>

<style lang='scss' scoped>
/* 导航栏样式 */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 80px;
    padding: 0 20px;
    background: rgba(255, 255, 255, 0.1);
  }
  
  .navbar-container {
    max-width: 1440px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
      align-items: center;
    }
    
    .logo-container {
      display: flex;
      align-items: center;
    }
    
    .logo {
      height: 40px;
      width: auto;
      margin-right: 10px;
    }
    
    .logo-text {
      font-size: 24px;
      font-weight: bold;
      color: #0F0023;
    }
    
    .nav-links {
      display: flex;
      align-items: center;
    
      @media (max-width: 768px) {
        display: none;
      }
    }
.desktop-only {
  @media (max-width: 768px) {
    display: none !important;
  }
}

.mobile-only {
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
}
    
    .nav-link {
      margin: 0 15px;
      font-size: 16px;
      color: white;
      stroke: black;
      stroke-width: 3px;
      text-decoration: none;
      transition: all 0.3s ease;
      cursor: pointer;
    
      &:hover {
        background: linear-gradient(90deg, #4843FE 0%, #FF4BA7 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: transparent;
      }
    }
    
    .top-up-btn {
      background: linear-gradient(90deg, #4843FE 0%, #FF4BA7 100%);
      color: white;
      padding: 10px 24px;
      border-radius: 24px;
      font-weight: 600;
      margin-left: 15px;
      text-decoration: none;
      transition: transform 0.3s ease;
    
      &:hover {
        transform: scale(1.05);
      }
    }
    

    
    /* 全屏滚动容器 */
.fullpage-container {
  overflow: hidden;
  padding-bottom: 60px;
    /* 为footer留出空间 */
  
    @media (max-width: 768px) {
      padding-bottom: 50px;
        /* 移动端footer高度优化 */
      }
      
      @media (max-width: 480px) {
        padding-bottom: 40px;
        /* 超小屏footer高度进一步优化 */
      }
      }
      
      .fullpage-wrapper {
        width: 100%;
        height: 500vh;
        transition: transform 1s cubic-bezier(0.86, 0, 0.07, 1);
      }
      
      .fullpage-section {
        height: 100vh;
        display: flex;
        flex-direction: column;
      
        &:first-child {
          padding-top: 80px;
        }
      }
      
      /* 第0部分样式 */
      .section-0 {
        overflow: hidden;
        position: relative;
        min-height: 100vh;
      }
      
      /* 下载按钮样式 */
      .download-btn {
        width: 240px;
        height: 72px;
        border-radius: 36px;
        background: #000;
        color: #fff;
        padding: 0 20px;
        transition: all 0.3s ease;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      
        &:hover {
          transform: scale(1.05);
          background: #333;
        }
      
        span {
          display: block;
          line-height: 1.2;
        }
      
        img {
          width: 36px;
          height: 40px;
          object-fit: contain;
        }
      
        .channel-name {
          font-size: 22px;
          font-weight: 600;
          margin-top: 2px;
        }
      
        @media (max-width: 1200px) {
          width: 220px;
          height: 64px;
          border-radius: 32px;
      
          img {
            width: 32px;
            height: 36px;
          }
      
          .channel-name {
            font-size: 20px;
          }
        }
      
        @media (max-width: 768px) {
          width: 240px;
          height: 56px;
          border-radius: 28px;
      
          img {
            width: 28px;
            height: 32px;
          }
      
          .channel-name {
            font-size: 18px;
          }
        }
      
        @media (max-width: 480px) {
          width: 220px;
          height: 50px;
          border-radius: 25px;
      
          img {
            width: 24px;
            height: 28px;
          }
      
          .channel-name {
            font-size: 16px;
          }
        }
      }
      
      /* 防止内容溢出 */
      .section-content {
        max-height: 100vh;
        overflow-y: auto;
        scrollbar-width: none;
      
        &::-webkit-scrollbar {
          display: none;
        }
      
        @media (max-width: 1024px) {
          display: flex;
          flex-direction: column;
          /* 小屏避免垂直居中导致内容偏下（如 iPhone SE） */
          justify-content: flex-start;
          text-align: center;
      
          h1 {
            margin-top: 0.75rem;
          }
      
          p {
            margin-left: auto;
            margin-right: auto;
          }
        }

        @media (max-width: 1024px) and (max-height: 700px) {
          h1 {
            margin-top: 0.25rem;
          }
        }
      }
      
      /* 动画效果 */
      @keyframes float {
      
        0%,
        100% {
          transform: translateY(0);
        }
      
        50% {
          transform: translateY(-15px);
        }
      }
      
      @keyframes float-slow {
      
        0%,
        100% {
          transform: translateY(0);
        }
      
        50% {
          transform: translateY(-10px);
        }
      }
      
      .animate-float {
        animation: float 4s ease-in-out infinite;
      }
      
      .animate-float-slow {
        animation: float-slow 6s ease-in-out infinite;
      }
      
      .animate-float-delay {
        animation: float 5s ease-in-out 1s infinite;
      }
      
      /* 第4部分样式 - 用户评价区 */
      .section-4 {
        padding: 40px 0;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: hidden;

        /* 移动端适配 */
        @media (min-width: 375px) and (max-width: 390px) {
          .section-content {
            padding-top: 2rem;
            padding-bottom: 2rem;
          }
        }

        @media (max-width: 640px) {
          .section-content {
            padding-top: 4rem;
            padding-bottom: 4rem;
          }
        }
        
        /* 平板适配 */
        @media (min-width: 768px) and (max-width: 1024px) {
          .section-content {
            padding-top: 6rem;
          }
        }

        /* 平板适配 */
        @media (min-width: 1024px) and (max-width: 1440px) {
          .section-content {
            padding-top: 8rem;
          }
        }
        /* 平板适配 */
        @media (min-width: 1440px) {
          .section-content {
            padding-top: 20rem;
          }
        }
      }
      
      .testimonials-header {
        text-align: center;
        margin-bottom: 60px;
        width: 100%;
        position: relative;
        z-index: 20;

        @media (max-width: 768px) {
          margin-bottom: 30px;
        }

        @media (max-width: 480px) {
          margin-bottom: 20px;
        }
      }
      
      .testimonials-title {
        font-size: 48px;
        font-weight: bold;
        color: #0F0023;
        margin-bottom: 20px;

        @media (max-width: 768px) {
          font-size: 36px;
          margin-bottom: 14px;
        }

        @media (max-width: 480px) {
          font-size: 28px;
          margin-bottom: 10px;
        }
      }
      
      .testimonials-subtitle {
        font-size: 20px;
        color: rgba(85, 76, 102, 0.9);
        max-width: 650px;
        margin: 0 auto;
        line-height: 1.6;

        @media (max-width: 768px) {
          font-size: 16px;
        }

        @media (max-width: 480px) {
          font-size: 14px;
          line-height: 1.5;
        }
      }
      
      .testimonials-container {
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
      }
      
      .testimonials-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
        width: 100%;
        height: 600px;
      }
      
      .testimonial-column {
        height: 100%;
        overflow: hidden;
        position: relative;
      
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 60px;
          background: linear-gradient(to bottom, #FFF3FF 40%, rgba(255, 243, 255, 0));
          z-index: 10;
          pointer-events: none;
        }
      
        @media (max-width: 768px) {
          height: auto;
          overflow: visible;
        }
      }
      
      .testimonial-column-inner {
        position: relative;
        margin-top: 20px;
      }
      
      /* 滚动动画 */
      .column-1 .testimonial-column-inner {
        animation: scrollUpInfinite 20s linear infinite;
      }
      
      .column-2 .testimonial-column-inner {
        animation: scrollUpInfinite 25s linear infinite;
      }
      
      .column-3 .testimonial-column-inner {
        animation: scrollUpInfinite 30s linear infinite;
      }
      
      .testimonial-column:hover .testimonial-column-inner {
        animation-play-state: paused;
      }
      
      @keyframes scrollUpInfinite {
        0% {
          transform: translateY(0);
        }
      
        100% {
          transform: translateY(-50%);
        }
      }
      
      /* 评价卡片样式 */
      .testimonial-card {
        border-radius: 16px;
        padding: 25px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
        background: #fff;
        margin-bottom: 30px;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
      
        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
          z-index: 5;
          position: relative;
        }
      }
      
      .rating {
        margin-bottom: 16px;
      
        .star {
          background: linear-gradient(0deg, #4843FE -35%, #FF4BA7 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          color: transparent;
          font-size: 20px;
          margin-right: 2px;
          display: inline-block;
        }
      }
      
      .testimonial-title {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 12px;
        color: #0F0023;
        line-height: 1.4;
      }
      
      .testimonial-text {
        font-size: 15px;
        line-height: 1.6;
        color: rgba(85, 76, 102, 0.9);
        margin-bottom: 20px;
      }
      
      .testimonial-author {
        font-size: 14px;
        color: #0F0023;
        font-weight: 500;
      }
      
      /* 响应式显示控制 */
      .mobile-only-card,
      .medium-screen-only,
      .small-screen-only {
        display: none;
      }
      
      .medium-large-screen,
      .large-screen-only {
        display: block;
      }
      
      /* 大屏幕(1200px以上): 显示所有3列 */
      @media (min-width: 1200px) {
        .testimonials-grid {
          grid-template-columns: repeat(3, 1fr);
        }
      }
      
      /* 中屏幕(768px-1200px): 显示2列 */
      @media (max-width: 1199px) and (min-width: 769px) {
        .testimonials-grid {
          grid-template-columns: repeat(2, 1fr);
        }
      
        .large-screen-only {
          display: none;
        }
      
        .medium-screen-only {
          display: block;
        }
      }
      
      /* 小屏幕(768px以下): 1列滚动 */
      @media (max-width: 768px) {
        .testimonials-grid {
          display: grid;
          grid-template-columns: 1fr;
          height: 500px;
          overflow: hidden;
        }
      
        .testimonial-column {
          height: 100%;
          overflow: hidden;
        }
      
        .testimonial-column::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 60px;
          background: linear-gradient(to bottom, #FFF3FF 40%, rgba(255, 243, 255, 0));
          z-index: 10;
          pointer-events: none;
        }
      
        .medium-large-screen,
        .large-screen-only {
          display: none;
        }
      
        .small-screen-only {
          display: block;
        }
      
        .testimonial-card {
          padding: 15px;
          margin-bottom: 15px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        }
      
        .testimonial-title {
          font-size: 16px;
          margin-bottom: 8px;
        }
      
        .testimonial-text {
          font-size: 14px;
          margin-bottom: 12px;
        }
      
        .testimonial-author {
          font-size: 12px;
        }
      
        .rating .star {
          font-size: 16px;
        }
      }
      
      /* 超小屏幕优化 */
      @media (max-width: 480px) {
        .testimonials-grid {
          height: 400px;
        }
      
        .testimonial-card {
          padding: 10px;
          margin-bottom: 10px;
        }
      }
      
      /* 移动端适配 */
      @media (max-width: 640px) {
        .section-content {
          padding-top: 1rem;
          padding-bottom: 1rem;
        }
      }
      
      /* 平板适配 */
      @media (min-width: 768px) and (max-width: 1024px) {
        .section-content {
          padding: 2rem;
        }
      }
      
      /* 横屏手机适配 */
      @media (max-height: 500px) and (orientation: landscape) {
        .section-content {
          padding: 1rem;
      
          h1 {
            font-size: 1.75rem !important;
            margin-bottom: 0.5rem;
          }
      
          p {
            font-size: 1rem !important;
          }
        }
      }
      
      /* 侧边导航点样式 */
      .pagination {
        position: fixed;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1000;
        display: flex;
        flex-direction: column;
        gap: 15px;
      
        @media (max-width: 768px) {
          right: 20px;
          gap: 12px;
        }
      }
      
      .pagination-dot {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.5);
        border: 2px solid rgba(15, 0, 35, 0.3);
        cursor: pointer;
        transition: all 0.3s ease;
      
        &:hover {
          background: rgba(255, 255, 255, 0.8);
          border-color: rgba(15, 0, 35, 0.6);
          transform: scale(1.2);
        }
      
        &.active {
          background: #4843FE;
          border-color: #4843FE;
          transform: scale(1.3);
        }
      
        @media (max-width: 768px) {
          width: 10px;
          height: 10px;
        }
      }
      
      .bg-image1 {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: auto;
        max-width: 1140px;
        height: 88vh;
        z-index: 1;
      
        @media (max-width: 1199px) {
          height: 75vh;
          max-width: 900px;
        }
      
        @media (max-width: 992px) {
          height: 70vh;
          // max-width: 750px;
        }
      
        @media (max-width: 768px) {
          height: 65vh;
          // max-width: 600px;
        }
      
        @media (max-width: 480px) {
          height: 60vh;
          // max-width: 90%;
        }
      }
      
      .bg-image2 {
        position: absolute;
        bottom: 45%;
        left: 50%;
        transform: translateX(-50%);
        height: 30vh;
        z-index: 5;
      
        @media (max-width: 1199px) {
          height: 28vh;
          bottom: 36%;
        }
      
        @media (max-width: 992px) {
          height: 25vh;
          bottom: 37%;
        }
      
        @media (max-width: 768px) {
          height: 22vh;
          bottom: 38%;
        }
      
        @media (max-width: 480px) {
          height: 20vh;
          bottom: 40%;
        }
      }
      
      .section-0-desc {
        font-family: Poppins;
        font-weight: 400;
        font-size: 24px;
        text-align: center;
        color: rgba(85, 76, 102, 1);
        position: absolute;
        bottom: 25%;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        text-align: center;
        max-width: 750px;
        line-height: 1.5;
        padding: 0 20px;
        z-index: 99;
      
        @media (min-width: 1440px) {
          font-size: 26px;
          max-width: 800px;
        }
      
        @media (max-width: 1199px) {
          font-size: 22px;
        }
      
        @media (max-width: 992px) {
          font-size: 20px;
          bottom: 28%;
        }
      
        @media (max-width: 768px) {
          font-size: 18px;
          top: 20%;
          padding: 0 30px;
        }
      
        @media (max-width: 480px) {
          font-size: 16px;
          top: 16%;
          bottom: 32%;
          padding: 0 25px;
        }
      }
      
      .section-0-buttons {
        position: absolute;
        bottom: 12%;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        justify-content: center;
        gap: 24px;
        z-index: 10;
      
        @media (max-width: 992px) {
          bottom: 15%;
          gap: 20px;
        }
      
        @media (max-width: 768px) {
          flex-direction: column;
          gap: 16px;
          bottom: 18%;
          align-items: center;
        }
      
        @media (max-width: 480px) {
          bottom: 20%;
          gap: 12px;
        }
      }
      
      /* Footer样式 */
      .footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #000;
        color: #fff;
        padding: 16px 0;
          z-index: 1000;
            border-top: 1px solid rgba(255, 255, 255, 0.1);
          
            @media (max-width: 768px) {
              padding: 8px 0;
            }
          
            @media (max-width: 480px) {
              padding: 6px 0;
            }
          }
          
          .footer-container {
            max-width: 1440px;
            margin: 0 auto;
            padding: 0 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          
            @media (max-width: 768px) {
              flex-direction: column;
              gap: 8px;
              text-align: center;
              padding: 0 16px;
            }
          
            @media (max-width: 480px) {
              gap: 6px;
              padding: 0 12px;
            }
          }
          
          .footer-left {
            .copyright {
              font-size: 16px;
              color: #fff;
          
              @media (max-width: 768px) {
                font-size: 14px;
              }
          
              @media (max-width: 480px) {
                font-size: 12px;
              }
            }
          }
          
          .footer-right {
            display: flex;
            align-items: center;
            gap: 12px;
          
            @media (max-width: 768px) {
              flex-wrap: wrap;
              justify-content: center;
              gap: 6px;
            }
          
            @media (max-width: 480px) {
              gap: 4px;
            }
          
            .footer-link {
              color: #fff;
              text-decoration: none;
              font-size: 16px;
              transition: color 0.3s ease;
          
              &:hover {
                background: linear-gradient(90deg, #4843FE 0%, #FF4BA7 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                color: transparent;
              }
          
              @media (max-width: 768px) {
                font-size: 14px;
              }
          
              @media (max-width: 480px) {
                font-size: 12px;
              }
            }
          
            .separator {
              color: #fff;
              font-size: 16px;
          
              @media (max-width: 768px) {
                font-size: 14px;
              }
          
              @media (max-width: 480px) {
                font-size: 12px;
              }
            }
          
            .contact {
              color: #fff;
              font-size: 16px;
          
              @media (max-width: 768px) {
                font-size: 14px;
              }
          
              @media (max-width: 480px) {
                font-size: 12px;
              }
            }
          }
.pwa-icon{
  width: 64px !important;
  object-fit: cover !important;
}
</style>
